import React from "react";

const FileUploadIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.25 14.25H9.75V11.1187L10.95 12.3187L12 11.25L9 8.25L6 11.25L7.06875 12.3L8.25 11.1187V14.25ZM4.5 16.5C4.0875 16.5 3.7345 16.3533 3.441 16.0597C3.1475 15.7662 3.0005 15.413 3 15V3C3 2.5875 3.147 2.2345 3.441 1.941C3.735 1.6475 4.088 1.5005 4.5 1.5H10.5L15 6V15C15 15.4125 14.8533 15.7657 14.5597 16.0597C14.2662 16.3538 13.913 16.5005 13.5 16.5H4.5ZM9.75 6.75V3H4.5V15H13.5V6.75H9.75Z"
      fill="white"
    />
  </svg>
);

export default FileUploadIcon;
